import React from 'react'
import App from 'next/app'
import { Provider } from 'react-redux'
import Head from 'next/head'

import TheApp from 'lib/pages/App'
import SEO from 'lib/components/SEO'
import { isNoindexPath } from 'lib/seo/noindexPaths'
import 'lib/ui/globals.css'

import createStore from 'lib/store'
import { WebVitals } from 'lib/util/webVitals'

const store = createStore()

class MyApp extends App {
  componentDidMount() {
    this.handleRouteChange = url => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'page_view', {
          page_path: url,
          page_title: document.title,
        })
      }
    }
    this.props.router.events.on('routeChangeComplete', this.handleRouteChange)
  }

  componentWillUnmount() {
    if (this.handleRouteChange) {
      this.props.router.events.off(
        'routeChangeComplete',
        this.handleRouteChange,
      )
    }
  }

  render() {
    const { Component, pageProps, router } = this.props
    const robots = isNoindexPath(router.pathname) ? 'noindex,follow' : undefined

    return (
      <Provider store={store}>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="buildId" content={process.env.BUILD_ID} />
        </Head>
        <SEO robots={robots} />

        <WebVitals />
        <TheApp Component={Component} pageProps={pageProps} />
      </Provider>
    )
  }
}

export default MyApp
